export enum borrowStatuses {
  request_pending = 0,
  request_rejected = 10,
  request_canceled = 20,
  sync_address_pending = 30,
  sync_pending = 40,
  active = 50,
  extension_pending = 60,
  terminated = 70,
}